import api from "../services/authService";

/**
 * The firm directory behind the Referrals section (dms_backend
 * `referrals/staff_api.py`; Matthew, 2026-11-02: "add a Referrals section
 * now"). Administrators only — the server refuses everyone else.
 *
 * Every write answers with the firm's full detail (firm, people,
 * referrals) so the page can replace what it shows without a second call.
 * Invitations come back as `invitation: {invited, reason, message}`;
 * `reason` is "portal_off" where the firms' portal is not switched on
 * yet and "email_failed" when the mail could not go.
 */

const data = (promise) => promise.then((response) => response.data);

export const fetchFirms = async () => data(api.get("/referrals/admin/firms/"));
export const fetchFirm = async (firmId) => data(api.get(`/referrals/admin/firms/${encodeURIComponent(firmId)}/`));
export const createFirm = async (body) => data(api.post("/referrals/admin/firms/", body));
export const updateFirm = async (firmId, body) =>
  data(api.patch(`/referrals/admin/firms/${encodeURIComponent(firmId)}/`, body));
export const addPerson = async (firmId, body) =>
  data(api.post(`/referrals/admin/firms/${encodeURIComponent(firmId)}/people/`, body));
export const updatePerson = async (personId, body) =>
  data(api.patch(`/referrals/admin/people/${encodeURIComponent(personId)}/`, body));
export const invitePerson = async (personId) =>
  data(api.post(`/referrals/admin/people/${encodeURIComponent(personId)}/invite/`, {}));

/** What the account column says about a person at the firm. */
export const ACCOUNT_LABEL = {
  ready: "Has an account",
  invited: "Invitation sent",
  invitation_expired: "Invitation expired",
  not_invited: "Not invited yet",
};

/** Plain words for a referral's place, from the two server fields. */
export const describeReferral = (row) => {
  if (!row) return "";
  if (row.status === "sent") return "Waiting on the firm";
  if (row.status === "turned_down") return "Declined by the firm";
  if (row.status === "expired") return "Expired — no answer";
  if (row.status === "withdrawn") return "Withdrawn";
  if (row.status === "signed_up") {
    if (row.signUpOutcome === "signed") return "Client signed";
    if (row.signUpOutcome === "not_signed") return "Client did not sign";
    return "Accepted — client not yet signed";
  }
  return row.statusLabel || "";
};

export const describeError = (error) =>
  error?.response?.data?.error || error?.response?.data?.detail || error?.message || "Something went wrong.";
